import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

// Component to control popup opening for selected markers
export const PopupControl = ({ markerRef, isSelected }) => {
  const map = useMap();

  useEffect(() => {
    if (isSelected && markerRef.current) {
      markerRef.current.openPopup();
    }
  }, [isSelected, markerRef]);

  return null;
};

// Component to control map center and zoom
export const MapController = ({ center, zoom }) => {
  const map = useMap();

  useEffect(() => {
    if (center && zoom) {
      map.setView(center, zoom);
    }
  }, [center, zoom, map]);

  return null;
};

// Force Leaflet to recalculate size on mount and on window resize
export const InvalidateSizeOnLoad = () => {
  const map = useMap();
  useEffect(() => {
    const invalidate = () => {
      try { map.invalidateSize(); } catch (e) {}
    };
    const id = setTimeout(invalidate, 0);
    window.addEventListener('resize', invalidate);
    return () => {
      clearTimeout(id);
      window.removeEventListener('resize', invalidate);
    };
  }, [map]);
  return null;
};

// Function to create avatar marker icons for employee locations
export const createAvatarIcon = (avatarUrl, initials) => {
  return L.divIcon({
    className: 'avatar-marker',
    html: avatarUrl ? 
      `<img src="${avatarUrl}" alt="avatar" class="marker-avatar" />` :
      `<div class="marker-initials">${initials}</div>`,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
  });
};

// Function to create custom task markers with status colors
export const createTaskMarkerIcon = (status, isSelected) => {
  const getTaskStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'incoming':
        return '#d97706';
      case 'in-progress':
        return '#17a2b8';
      case 'resolved':
        return '#28a745';
      case 'rejected':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  const color = getTaskStatusColor(status);
  return L.divIcon({
    className: `custom-marker ${isSelected ? 'selected' : ''}`,
    html: `
      <div class="marker-dot" style="
                background-color: ${color};
                width: 24px;
                height: 24px;
                border-radius: 50%;
                border: 2px solid white;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-weight: bold;
                font-size: 12px;
                position: relative;
            ">
                <span style="transform: translateY(1px)">•</span>
            </div>
    `,
    iconSize: [24, 24],
    iconAnchor: [12, 12]
  });
}; 